import { render, staticRenderFns } from "./RearrangeModal.vue?vue&type=template&id=652efa3e&scoped=true"
import script from "./RearrangeModal.vue?vue&type=script&lang=js"
export * from "./RearrangeModal.vue?vue&type=script&lang=js"
import style0 from "./RearrangeModal.vue?vue&type=style&index=0&id=652efa3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652efa3e",
  null
  
)

export default component.exports